import '@webcomponents/webcomponentsjs'

import { registerOutsideClickHandler } from './zaptic-outside-click-handler'

// IMPORTANT - When ADDING A NEW LIT ELEMENT - make sure to import it here or it will not render *anywhere*

// because of shared/webcomponents/test/webpack.ts.bundleComponents()
import './zaptic-assignee-select'
import './zaptic-tag-select'
import './zaptic-annotated-image'
import './zaptic-assignable-icon'
import './zaptic-centered-message'
import './zaptic-dynamic-condition'
import './zaptic-dynamic-conditions'
import './zaptic-ellipsis'
import './zaptic-filter-button'
import './zaptic-full-page-message'
import './zaptic-tile'
import './zaptic-external-link'
import './zaptic-i18n'
import './zaptic-icon'
import './zaptic-icon-lightning'
import './zaptic-info-popover'
import './zaptic-interval'
import './zaptic-labelled-circle'
import './zaptic-lozenge'
import './zaptic-language-sensitive-list-format'
import './zaptic-profile-circle'
import './zaptic-relative-time'
import './zaptic-select'
import './zaptic-select-box'
import './zaptic-spinner'
import './zaptic-stack'
import './zaptic-stack-item'
import './zaptic-tag'
import './zaptic-tag-input'
import './zaptic-radio'
import './zaptic-radio-group'
import './zaptic-modal'
import './zaptic-modal-v2'
import './zaptic-multi-select'
import './zaptic-no-notifications'
import './zaptic-notification-bell'
import './zaptic-popover'
import './zaptic-popup-button'
import './zaptic-popup-message-modal'
import './zaptic-checkbox'
import './zaptic-timeline-event'
import './zaptic-dropdown'
import './specific-use/'
import './zaptic-icon-procedure-wrench'
import './zaptic-team-badge'
import './zaptic-icon-unit-cube'
import './zaptic-workflow-icon'
import './zaptic-report-statuses'
import './zaptic-content-loop-settings'
import './zaptic-rotating-chevron'
import './unit-tree-select'
import './zaptic-icon-button'
import './zaptic-comment-adder'
import './zaptic-close-window-button'
import './zaptic-timeline-user'
import './zaptic-flexible-list-add'
import './zaptic-string-list'
import './zaptic-report-status'
import './zaptic-no-reports-error'
import './zaptic-report-subject'
import './zaptic-radio-old'
import './zaptic-subreport-widget'
import './zaptic-report-tile'
import './zaptic-deleted-assignee'
import './zaptic-spacer'
import './zaptic-dots-overview'
import './zaptic-answer-timeline'
import './zaptic-button'
import './zaptic-user-list'
import './zaptic-tag-list'
import './zaptic-rich-text'
import './zaptic-notification-item'
import './zaptic-powerbi-report'
import './zaptic-carousel'
import './zaptic-assignable-button'
import './zaptic-workflow-parameter-settings'

/**
 * @deprecated use 'extends LitElement' instead of 'HTMLElement' to create webcomponents, import these above **** ^^^ IMPORT THESE ABOVE ^^^ *******
 * @example `zaptic-assignee-select`
 */
window.addEventListener('load', () => {
    // Do NOT add any new lit/html components here. Instead, import them above.
    registerOutsideClickHandler()
})
